import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { isUserAnonymous } from 'modules/CardView/util/utils';
import { getProfileLastTouchFavorited } from 'utils/Socialization';
import PremiumPage from 'containers/PremiumPage/PremiumPage';
import { getContentList } from '../../redux/actions/cms.actions';
import { useGetItemType } from './hooks/useGetItemType';
import { useVerifyIsMobile } from '../../../../hooks/useVerifyIsMobile';

import { ContentsCarouselDreams } from './components/ContentsCarouselDreams';
import PlanOfferCarousel from './components/PlanOfferCarousel';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';

import './style.scss';
import {
  HEIGHT_FROM_CHEVRONES,
  MARGIN_BOTTOM_FROM_CHEVRONES,
} from './constants';
import { HighlightCarouselNew } from './components/HighlightCarousel/components/HighlightCarouselNew/HighlightCarouselNew';

//  ESTE COMPONENTE ES UN CARRUSEL CUSTOM
const ContentsCarouselContainer = ({
  title,
  carouselType,
  carouselSubType,
  config,
  index,
  node,
  name,
}) => {
  const dispatch = useDispatch();
  const { cmsNodes } = useSelector(state => state.cvCMS);
  const { userhash } = useSelector(state => state.user);
  const { getComponent } = useGetItemType();
  const { isMobile } = useVerifyIsMobile();

  const userType = useSelector(state => state.user.userType);
  const [hideCarousel, setHideCarousel] = useState(false);

  const lasttouch = localStorage.getItem('lasttouch');
  const lasttouchFavorited = getProfileLastTouchFavorited();
  const lasttouchSeen = localStorage.getItem('lasttouchSeen');
  const LASTTOUCH_REGEX = /lasttouch=/g;
  const isClaroAdsKey = useSelector(
    selectMetadataKeyByRegion('cv_advertising_config'),
  );
  const superHighlightRef = useRef(null);

  useEffect(() => {
    if (carouselType === 'planselector') setHideCarousel(true);
    if(isUserAnonymous(userType) && carouselType === 'CarrouselLiveEvents') return setHideCarousel(true);
    //  si no existe la propiedad contentList
    //  y si no es de tipo usuario dispara la accion
    if (
      !cmsNodes?.[node]?.carousels?.[index]?.hasOwnProperty('contentsList') &&
      config?.properties?.byuser !== 'true' &&
      config?.properties?.url
    ) {
      dispatch(
        getContentList({
          url: config?.properties?.url,
          index,
          node,
          carouselType,
          userhash,
        }),
      );
    }
    // si es de tipo usuario dispara la accion
    if (config?.properties?.byuser === 'true') {
      // Si el usuario no es anónimo y hay url a consumir
      if (
        (config?.properties?.url && !isUserAnonymous(userType)) ||
        (config?.properties?.url && isClaroAdsKey)
      ) {
        let { url } = config.properties;
        const isSeen = url.indexOf('/services/user/seen?') !== -1;
        const isFavorited = url.indexOf('/services/user/favorited?') !== -1;

        //  Se reemplaza  lasttouch desde el lasttouch de localStorage
        let lasttouchReplaced = '';
        if (isFavorited) {
          lasttouchReplaced = lasttouchFavorited;
        } else if (isSeen) {
          lasttouchReplaced = lasttouchSeen;
        } else {
          lasttouchReplaced = lasttouch;
        }
        url += `&lasttouch=${lasttouchReplaced}`;

        dispatch(
          getContentList({
            url,
            index,
            node,
            carouselType,
            userhash,
          }),
        );
      } else {
        setHideCarousel(true);
      }
    }
  }, []);

  const handleReload = () => {
    dispatch(
      getContentList({
        url: config.properties.url,
        index,
        node,
        carouselType,
        userhash,
      }),
    );
  };

  const currentCarousel = useMemo(
    () => {
      const carouselFinded = cmsNodes[node].carousels.find(
        carousel => carousel.name === name,
      );
      return carouselFinded;
    },
    [cmsNodes[node].carousels[index]],
  );

  const minHeight =
    superHighlightRef?.current?.clientHeight +
    HEIGHT_FROM_CHEVRONES +
    MARGIN_BOTTOM_FROM_CHEVRONES;
  if (hideCarousel) return null;

  const carruselClass = !currentCarousel?.hasOwnProperty('contentsList')
    ? 'loading'
    : '';

  return (
    <>
      <section
        style={
          {
            // minHeight: carouselType === 'Highlight' || carruselClass === 'loading' ? minHeight : ''
          }
        }
        className={`contents-carousel ${name} ${carouselType} ${carruselClass}`}
      >
        <Fragment>
          {carouselType !== 'Highlight' &&
            carouselType !== 'planselector' &&
            carouselType !== 'PremiumImage' &&
            carouselType !== 'PlansOfferV2' && (
              <ContentsCarouselDreams
                contentsList={currentCarousel?.contentsList}
                name={name}
                getComponent={getComponent}
                carouselType={carouselType}
                carouselSubType={carouselSubType}
                title={title}
                node={node}
                index={index}
                hasError={currentCarousel?.hasError}
                handleReload={handleReload}
                config={config}
              />
            )}
          {/* <----Carruseles secundarios */}
          {carouselType === 'Highlight' && (
            <HighlightCarouselNew
              contentsList={currentCarousel?.contentsList}
              name={name}
              isMobile={isMobile}
              hasError={currentCarousel?.hasError}
              handleReload={handleReload}
              superHighlightRef={superHighlightRef}
            />
            // <HighlightCarousel
            //   contentsList={currentCarousel?.contentsList}
            //   name={name}
            //   isMobile={isMobile}
            //   hasError={currentCarousel?.hasError}
            //   handleReload={handleReload}
            //   superHighlightRef={superHighlightRef}
            // />
          )}
          {carouselType === 'PlansOfferV2' && ( // offers
            <PlanOfferCarousel
              name={name}
              getComponent={getComponent}
              carouselType={carouselType}
              carouselSubType={carouselSubType}
              title={title}
              node={node}
              index={index}
              hasError={currentCarousel?.hasError}
              handleReload={handleReload}
              currentCarousel={currentCarousel}
            />
          )}

          {/* {carouselType === 'planselector' &&
           typeof currentCarousel?.contentsList?.[0].price === 'string' && (
             <PlanSelectorCarousel
               contentsList={currentCarousel?.contentsList}
               title={title}
               hasError={currentCarousel?.hasError}
               handleReload={handleReload}
             />
           )} */}
        </Fragment>

        {!!currentCarousel?.component?.properties &&
          carouselType === 'PremiumImage' && (
            <PremiumPage contentInfo={currentCarousel?.component?.properties} />
          )}
      </section>
    </>
  );
};

export default ContentsCarouselContainer;
